namespace Matrix.Data {
    export class HelpTextColumns {
        static columnsKey = 'Data.HelpText';
    }
}
